import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const lastTabId = this.getCookie("last_tab_id")
    const button = this.tabTargets.find(t => t.id === lastTabId) || this.tabTargets[0]
    if (button) this.select({ currentTarget: button })
  }

  async select(event) {
    const button = event.currentTarget
    const tabId = button.dataset.tabId
    const panel = document.getElementById(tabId)

    // Activer le bon bouton
    this.tabTargets.forEach(tab => tab.classList.remove("border-blue-500", "text-blue-600"))
    button.classList.add("border-blue-500", "text-blue-600")

    // Masquer tous les panels
    this.panelTargets.forEach(p => p.classList.add("hidden"))

    // Afficher le bon panel
    if (panel) {
      panel.classList.remove("hidden")
      const url = button.dataset.url

      if (url) {
        panel.innerHTML = `<div class="py-6 text-center text-gray-400">Chargement…</div>`
        try {
          const response = await fetch(url, { headers: { Accept: "text/html" } })
          if (!response.ok) throw new Error("Erreur serveur")

          const html = await response.text()
          panel.innerHTML = html
        } catch (error) {
          panel.innerHTML = `<p class="text-red-500 text-center py-4">Erreur de chargement</p>`
        }
      }
    }

    this.setCookie("last_tab_id", button.id, 30)
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
    return match ? decodeURIComponent(match[2]) : null
  }

  setCookie(name, value, days) {
    const d = new Date()
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${name}=${value}; path=/; expires=${d.toUTCString()}`
  }
}
